import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { LoadingConfig } from './models/loading.model';
import { LoadingService } from './loading.service';

const provideLoadingConfig = (config: Partial<LoadingConfig>) => ({ provide: LoadingConfig, useValue: config });

const provideLoadingService = () => ({
    provide: LoadingService,
    useFactory: (c: LoadingConfig) => new LoadingService(c),
    deps: [LoadingConfig]
});

export const provideLoading: (config: Partial<LoadingConfig>) => EnvironmentProviders = (config) => {
    const providers: Provider[] = [provideLoadingConfig(config), provideLoadingService()];

    return makeEnvironmentProviders(providers);
};
